import axios from 'axios'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

class BillingCommonAccountingUnitService {
    async getAllActiveAccountingUnits(): Promise<AccountingUnitResponse[]> {
        const response =
            await axios.get<AccountingUnitResponse[]>(
                `/billing/accountingUnits`)
        return response.data
    }
}
export const billingCommonAccountingUnitService = new BillingCommonAccountingUnitService()
